import { GlobeAltIcon } from "@heroicons/react/24/outline";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogDescription,
} from "@components/ui/dialog";
import { Button } from "@components/ui/button";

interface NeedsDomainModalProps {
  isOpen: boolean;
  onClose: () => void;
  /** Confirm — take the user to the site-name picker. */
  onConfirm: () => void;
}

/**
 * Shown when the user clicks Deploy before choosing a site name. Rather than
 * silently refusing (or flickering the picker open), we explain the missing
 * step and hand them straight to the picker on confirm.
 */
export function NeedsDomainModal({ isOpen, onClose, onConfirm }: NeedsDomainModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-[480px]" data-testid="needs-domain-modal">
        <DialogHeader>
          <div className="flex items-center gap-3">
            <div className="flex items-center justify-center size-10 rounded-full bg-primary-100">
              <GlobeAltIcon className="size-5 text-primary-600" />
            </div>
            <DialogTitle>Choose your site name first</DialogTitle>
          </div>
          <DialogDescription className="pt-3">
            Your site needs a web address before it can go live. Pick a site name and we&apos;ll
            get you deployed.
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className="gap-2 sm:gap-0">
          <Button variant="outline" onClick={onClose} data-testid="needs-domain-cancel">
            Cancel
          </Button>
          <Button onClick={onConfirm} data-testid="needs-domain-choose">
            Choose site name
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
